import { Container } from '@mui/material';
import BenefitDetailsLoading from 'src/modules/benefits/components/benefit-details-loading';
import Page from 'src/components/page/page';
import ProductForm from './components/product-form';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import RegisterCodes from './components/code-modal';
import RedeemsModal from './components/redeem-modal';
import RegisterCpfs from './components/cpf-modal';
import { useLPProductDetails } from './product-lp-details.hook';

export default function LPProductDetails() {
  const hook = useLPProductDetails();

  return (
    <Page title={hook.isEdit ? 'Editar Benefício' : 'Cadastrar Benefício'}>
      <Container maxWidth="xl">
        <HeaderBreadcrumbs
          heading={hook.isEdit ? 'Editar Benefício' : 'Cadastrar Benefício'}
          links={[]}
          sx={{ mb: 3 }}
        />
        {hook.isDetailsLoading ? <BenefitDetailsLoading /> : <ProductForm hook={hook} />}
        <RegisterCodes productDetailsHook={hook} />
        <RegisterCpfs productDetailsHook={hook} />
        <RedeemsModal productHook={hook} />
      </Container>
    </Page>
  );
}
